import React from "react";
import { ITopBookingsItems } from "@common-types";
import { formatMoneyCurrency } from "@share/utils";
import { USD_CURRENCY } from "@constants";
import { FormattedMessage } from "react-intl";

const HotelCard: React.FC<ITopBookingsItems> = (props) => {
  const { image, location, offerPrice, reviews, city } = props;
  return (
    <div className="col-sm-12">
      <div className="card card-img-scale overflow-hidden bg-transparent">
        <div className="card-img-scale-wrapper rounded-3">
          <img src={image} style={{ height: '282px', objectFit: 'cover' }} className="card-img" alt="hotel_ImageSection" />
          <div className="position-absolute bottom-0 start-0 p-3">
            <div className="badge text-bg-dark fs-6 rounded-pill stretched-link">
              <i className="bi bi-geo-alt me-2"></i>
              {city}
            </div>
          </div>
        </div>

        <div className="card-body px-2">
          <h5 className="card-title">
            <a href="hotel-detail.html" className="stretched-link">
              {location.name}
            </a>
          </h5>
          <div className="d-flex justify-content-between align-items-center">
            <h6 className="text-success mb-0">
              {formatMoneyCurrency(USD_CURRENCY).format(offerPrice)} <small className="fw-light">/ <FormattedMessage id="night" /></small>{" "}
            </h6>
            <h6 className="mb-0">
              {reviews}
              <i className="fa-solid fa-star text-warning ms-1"></i>
            </h6>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HotelCard;
